// removed by extract-text-webpack-plugin
module.exports = {"hero":"src-pages----blog-module---hero---TCejO"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/blog.module.css
// module id = 285
// module chunks = 212839066777427